import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export interface IVolumeLeagueTraderRanking {
    rank: number
    share: number // 리그 총 거래량 대비 점유율 % (0–100)
    trader_id: string
    buy_sell_ratio?: number // 매수 비중 0–100. symbol scope 리그만 실측, 그 외는 중립값 50
}

export interface IVolumeLeagueTrader {
    ranked: boolean
    updated_at?: number
    ranking?: IVolumeLeagueTraderRanking | null // ranked=false 면 null
}

// GET /v3/volume-league/:id/trader/:traderId — 특정 트레이더의 리그 순위 (volume 미포함)
export const getVolumeLeagueTrader = async (
    id: number | string,
    traderId: string,
): Promise<ApiRes<IVolumeLeagueTrader>> => {
    return await apiGet(API_URL, `volume-league/${id}/trader/${traderId}`)
}
